import React from 'react';
import './TestimonialCard.css';

const TestimonialCard = ({ photoUrl, name, role, testimonial }) => {
  return (
    <div id="testimonial-card" className="testimonial-card">
      <div className="testimonial-card-content">
        <div className="testimonial-text">
          <p className="testimonial-quote">"{testimonial}"</p>
        </div>
        <div className="testimonial-author">
          <div className="author-image-container">
            <img 
              src={photoUrl} 
              alt={name} 
              className="author-image" 
            />
          </div>
          <div className="author-info">
            <h4 className="author-name">{name}</h4>
            <p className="author-role">{role}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;